import React from 'react';

import styled from 'styled-components/native';

import { FOHLabel, FOHColors } from '../../ingredients';

interface FOHGrayTagProps {
  label: string;
  style?: any;
}

export const FOHGrayTag = (props: FOHGrayTagProps) => (
  <GrayTagText style={{ ...props.style }}>{props.label}</GrayTagText>
);

const GrayTagText = styled(FOHLabel)`
  font-size: 12px;
  color: #000000;
  text-align: center;
  border-radius: 100px;
  height: 24px;
  padding-left: 12px;
  padding-right: 12px;
  justify-content: center;
  background-color: ${FOHColors.GRAYSCALE_100};
  text-align: center;
  line-height: 20px;
  padding-top: 2px;
  padding-bottom: 2px;
  word-break: break-word;
  margin-top: 4px;
`;
